import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { LocalSettingsService } from '~app/core/storage';
import { SignInCallback, SignInFailure } from '../core/auth.actions';
import { OidcClientAuthService } from './oidc-client-auth.service';

@Component({
    selector: 'odq-signin-redirect-callback',
    template: `<div></div>`,
    standalone: false
})
export class SigninRedirectCallbackComponent implements OnInit {

  constructor(
    private oidcAuthService: OidcClientAuthService,
    private router: Router,
    private store: Store,
    private translate: TranslateService,
    private localSettings: LocalSettingsService) { }

  ngOnInit() {
    const errorFromFragment = this.getErrorFromHash(window.location.hash);
    if (errorFromFragment) {
      // Ensure HomeComponent's first-visit reload does not run and wipe
      // the dialog that is about to open.
      this.localSettings.setClearCache();
      this.store.dispatch(new SignInFailure(
        this.translate.instant('error.auth.no_authentication_service'),
      ));
      this.router.navigateByUrl('/', { replaceUrl: true });
      return;
    }

    this.oidcAuthService.completeLogin().then(returnPath => {
      console.log('completeLogin return-url', returnPath);
      this.store.dispatch(new SignInCallback());
      this.router.navigateByUrl(returnPath ?? '/', { replaceUrl: true });
    });
  }

  private getErrorFromHash(hash: string): string | null {
    if (!hash || hash.length < 2) return null;
    const params = new URLSearchParams(hash.startsWith('#') ? hash.substring(1) : hash);
    return params.get('error');
  }

}
